export default "__VITE_ASSET__DNK4n6uW__"